import { Button, DialogActions, DialogTitle } from "@mui/material";
import GTextField from "../../libs/textfield/GTextField";
import usePortfolio from "../../hooks/PortfolioProvider";
import { AccountTypes } from "../../shared/IAccount";
import Dropdown from "../../libs/dropdown/Dropdown";
import { useMemo, useRef } from "react";
import FormGroup from "../../libs/form/FormGroup";
import FormControl from "../../libs/form/FormControl";
import Validators from "../../libs/form/Validators";
import PortAccount from "../../models/PortAccount";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";
import { useDialog } from "../../libs/dialog/DialogProvider";
import CheckButton from "../../libs/button/CheckButton";

export default function EditAccount(props: { account: number }) {
    const { portfolio } = usePortfolio()

    const refName = useRef<any>()
    const refType = useRef<any>()
    const refHide = useRef<any>()

    const { setSnackbar } = useSnackbar()
    const { closeDialog } = useDialog()

    const form = useMemo(() => {
        return new FormGroup("account", [
            new FormControl("name", [Validators.Required])
        ])
    }, [])
    const account = portfolio.account(props.account)
    const onSave = async () => {
        form.markAllAsDirty()
        if (!form.valid) return
        try {
            await PortAccount.i.updateAccount(props.account, refName.current.value, refType.current.value, refHide.current.checked)
            closeDialog()
        } catch (e) {
            setSnackbar(e)
        }
    }
    return <>
        <DialogTitle>Edit</DialogTitle>
        <div className="content flex vert gap-24">
            <GTextField controlName="name" defaultValue={props.account>=0?portfolio.accountName(props.account):""} floatLabel="Account name" form={form} inputRef={refName} />
            <Dropdown options={AccountTypes} defaultValue={account?.type || 0} label="Account type" ref={refType} />            
            <CheckButton label="Hide" defaultChecked={!!account?.hide} inputRef={refHide}/>
        </div>
        <DialogActions>
            <Button onClick={onSave}>Save</Button>
        </DialogActions>
    </>
}